module.exports = __webpack_public_path__ + "img/Kanto3Preview.3d1123a7.png";